<template>
  <main class="tool-page tool-page-wide">
    <div class="preview-grid">
      <el-card shadow="never" class="panel">
        <div slot="header" class="panel-head">
          <div>
            <p class="panel-kicker">Base64</p>
            <h2>字符串输入</h2>
          </div>
          <div class="toolbar-inline">
            <el-button plain @click="fillSampleBase64">示例</el-button>
            <el-button plain @click="clearInput">清空</el-button>
          </div>
        </div>

        <el-form label-position="top" @submit.native.prevent>
          <el-form-item label="Base64 字符串或 Data URL">
            <el-input
              v-model="base64Input"
              type="textarea"
              :rows="18"
              resize="vertical"
              placeholder="粘贴 base64 图片字符串，例如 data:image/png;base64,iVBORw0KGgoAAA..."
            />
          </el-form-item>

          <div class="actions">
            <el-button type="primary" @click="previewImage">预览图片</el-button>
            <el-button @click="copyCurrentValue">复制输入内容</el-button>
          </div>
        </el-form>

        <p class="status" :class="previewStatus.type">{{ previewStatus.message }}</p>
      </el-card>

      <el-card shadow="never" class="panel">
        <div slot="header" class="panel-head">
          <div>
            <p class="panel-kicker">Preview</p>
            <h2>图片预览</h2>
          </div>
        </div>

        <div class="preview-stage" :class="{ empty: !previewUrl }">
          <img v-if="previewUrl" :src="previewUrl" alt="Base64 预览图片" class="preview-image" />
          <p v-else>输入 Base64 图片字符串后，这里会显示预览结果</p>
        </div>
      </el-card>
    </div>
  </main>
</template>

<script>
const SAMPLE_BASE64 =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMjAiIGhlaWdodD0iMjIwIiB2aWV3Qm94PSIwIDAgMzIwIDIyMCI+PHJlY3Qgd2lkdGg9IjMyMCIgaGVpZ2h0PSIyMjAiIHJ4PSIyNCIgZmlsbD0iI0Y1RUZFNCIvPjxjaXJjbGUgY3g9Ijk2IiBjeT0iODQiIHI9IjI4IiBmaWxsPSIjQzg1QzM1IiBmaWxsLW9wYWNpdHk9Ii44NSIvPjxyZWN0IHg9IjYwIiB5PSIxMjYiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjQiIHJ4PSIxMiIgZmlsbD0iI0RBQzVBRiIvPjxyZWN0IHg9IjYwIiB5PSIxNjIiIHdpZHRoPSIxNDQiIGhlaWdodD0iMTgiIHJ4PSI5IiBmaWxsPSIjRTlEOEMwIi8+PHRleHQgeD0iMTYwIiB5PSIxMDIiIGZvbnQtZmFtaWx5PSJQaW5nRmFuZyBTQywgTWljcm9zb2Z0IFlhSGVpLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjI2IiBmb250LXdlaWdodD0iNzAwIiBmaWxsPSIjMkIyMTE3IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5CYXNlNjQ8L3RleHQ+PC9zdmc+";

export default {
  name: "Base64ImagePage",
  data() {
    return {
      base64Input: "",
      previewUrl: "",
      previewStatus: {
        message: "等待输入",
        type: "",
      },
    };
  },
  methods: {
    setStatus(message, type) {
      this.previewStatus = {
        message,
        type: type || "",
      };
    },
    normalizeBase64(value) {
      const raw = value.trim();
      if (!raw) {
        throw new Error("请先输入 Base64 内容");
      }
      if (raw.startsWith("data:image/")) {
        return raw;
      }
      return `data:image/png;base64,${raw.replace(/\s+/g, "")}`;
    },
    previewImage() {
      try {
        this.previewUrl = this.normalizeBase64(this.base64Input);
        this.setStatus("图片已生成预览", "success");
      } catch (error) {
        this.previewUrl = "";
        this.setStatus(error.message, "error");
      }
    },
    fillSampleBase64() {
      this.base64Input = SAMPLE_BASE64;
      this.previewImage();
    },
    clearInput() {
      this.base64Input = "";
      this.previewUrl = "";
      this.setStatus("已清空 Base64 输入与预览", "success");
    },
    async copyCurrentValue() {
      const value = (this.base64Input || "").trim();
      if (!value) {
        this.$message.error("没有可复制的内容");
        return;
      }
      try {
        await navigator.clipboard.writeText(value);
        this.$message.success("已复制 Base64 内容");
      } catch (error) {
        this.$message.error("复制失败，请检查浏览器权限");
      }
    },
  },
};
</script>

<style scoped>
.tool-page-wide {
  max-width: 1180px;
}

.preview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 420px);
  gap: 24px;
}

.preview-stage {
  min-height: 520px;
  border: 1px dashed rgba(74, 56, 33, 0.18);
  border-radius: 24px;
  background:
    linear-gradient(45deg, rgba(255, 255, 255, 0.52) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(255, 255, 255, 0.52) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.52) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.52) 75%);
  background-size: 24px 24px;
  background-position: 0 0, 0 12px, 12px -12px, -12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  overflow: hidden;
}

.preview-stage.empty {
  color: #7b6855;
}

.preview-stage p {
  margin: 0;
  text-align: center;
  line-height: 1.7;
}

.preview-image {
  max-width: 100%;
  max-height: 480px;
  object-fit: contain;
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(93, 59, 22, 0.14);
}

@media (max-width: 960px) {
  .preview-grid {
    grid-template-columns: 1fr;
  }

  .preview-stage {
    min-height: 320px;
  }
}
</style>
